@if (useNewLayout()) {
  <div class="flex flex-col min-h-screen">
    <app-system-banner />
    <div class="flex-grow relative flex [&>*]:flex-grow">
      <router-outlet class="hidden" />
    </div>
  </div>
} @else {
  <div class="flex flex-col min-h-screen">
    <div class="shadow z-40">
      <app-navigation />
    </div>
    <app-system-banner />
    <div class="flex-grow relative flex [&>*]:flex-grow">
      <router-outlet class="hidden" />
    </div>
    <div class="z-40">
      <app-footer />
    </div>
  </div>
}
